import { Button } from '@/components/ui/button'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import ConfirmDialog from 'app/frontend/base/components/ConfirmDialog'
import { leaveTeam } from 'app/frontend/base/api/team'
import { useTeam } from 'app/frontend/base/config/context/team'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { displayErrorToast } from 'app/frontend/base/helpers'

const LeaveTeamButton = () => {
  const { t } = useTranslation()
  const { team } = useTeam()
  const {
    data: { user },
  } = usePageInfo()
  const queryClient = useQueryClient()
  const [confirmOpen, setConfirmOpen] = useState(false)

  const ownMembers =
    team.members?.filter(
      (member) => user && member.characterReference.userId === user.id,
    ) ?? []

  const { mutateAsync: leave, isPending } = useMutation({
    mutationFn: () => leaveTeam(team.id),
    onSuccess: (newData) => {
      queryClient.setQueryData(['team', { path: team.path }], newData)
      toast.success(t('dashboard.team.roster.leave-team-success'))
    },
    onError: (error) => {
      displayErrorToast(error, t)
    },
  })

  if (ownMembers.length === 0) {
    return null
  }

  return (
    <>
      <Button
        variant='ghost'
        size='sm'
        className='text-muted-foreground'
        onClick={() => setConfirmOpen(true)}
      >
        {t('dashboard.team.roster.leave-team')}
      </Button>
      <ConfirmDialog
        open={confirmOpen}
        variant='destructive'
        title={t('dashboard.team.roster.leave-team-title')}
        description={t('dashboard.team.roster.leave-team-description')}
        continueText={t('dashboard.team.roster.leave-team')}
        loading={isPending}
        onCancel={() => setConfirmOpen(false)}
        onContinue={async () => {
          try {
            await leave()
            setConfirmOpen(false)
          } catch {
            // Error toast is already shown; keep the dialog open.
          }
        }}
      />
    </>
  )
}

export default LeaveTeamButton
